import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { Badge } from "react-bootstrap";

const CardItem = ({ item, index, selectTab }) => {
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	return (
		<tr key={index} className="text-center">
			<td className="text-wrap-mode">{item.name_en}</td>
			<td>{item.numberOfParkings}</td>
			<td>
				{item.totalPrice?.toFixed(3)} {Translate[lang].kwd}
			</td>
		</tr>
	);
};
export default CardItem;
